import React, { useMemo } from 'react'

import {
  useSessionPreviewTitle,
  useStaffAIAssistant,
} from 'src/components/StaffAIAssistant/StaffAIAssistantContext'
import { useGetStaffAIChatSessionsQuery } from 'src/fetch/staffAIChat'
import { HStack, Icon, T, VStack } from 'src/govwell-ui'

type Props = {
  onClose: () => void
}

const StaffAIChatHeader = ({ onClose }: Props) => {
  const context = useStaffAIAssistant()
  const { sessions } = useGetStaffAIChatSessionsQuery()

  // Find the active session to get its title
  const activeSession = useMemo(() => {
    if (!context?.activeSessionId) return null
    return sessions.find((s) => s.id === context.activeSessionId) ?? null
  }, [context?.activeSessionId, sessions])

  const title = useSessionPreviewTitle(activeSession)

  return (
    <div className="shrink-0 border-b border-neutral-200 bg-white px-6 py-4">
      <HStack gap={3}>
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-neutral-900">
          <Icon.FaSparkles className="h-5 w-5 text-white" />
        </div>
        <VStack gap={0}>
          <HStack gap={2}>
            <T.Body className="max-w-md truncate font-semibold text-neutral-900">{title}</T.Body>
            <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
              Beta
            </span>
          </HStack>
          <T.BodySmall className="text-neutral-500">GovWell AI Assistant</T.BodySmall>
        </VStack>
        <div className="flex-1" />
        <button
          type="button"
          onClick={onClose}
          className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full border border-neutral-300 bg-neutral-100 transition-colors hover:bg-neutral-200"
          aria-label="Minimize"
        >
          <span className="h-0.5 w-3 rounded-full bg-neutral-500" />
        </button>
      </HStack>
    </div>
  )
}

export default React.memo(StaffAIChatHeader)
